import React, { FunctionComponent } from 'react';
import { useDispatch } from 'react-redux';
import useTypedSelector from 'hooks/useTypedSelector';

import { updateSystemStatus } from 'redux/actions/systemStatus.actions';
import { systemStatusSelector } from 'redux/selectors/systemStatus.selector';
import { IUpdateSystemStatusPayload } from 'types/systemStatus.types';
import i18next from 'i18next';
import 'views/SystemStatusView/i18n';
import SystemStatusView from 'views/SystemStatusView';
import LayoutContainer from './LayoutContainer';

const SystemStatusContainer: FunctionComponent = () => {
  const dispatch = useDispatch();
  const status = useTypedSelector(systemStatusSelector);

  const handleSave = (values: IUpdateSystemStatusPayload) => {
    dispatch(updateSystemStatus(values));
  };

  return (
    <LayoutContainer auth title={i18next.t<string>('SYSTEM_STATUS:TITLE')}>
      <SystemStatusView status={status} onSave={handleSave} />
    </LayoutContainer>
  );
};

export default SystemStatusContainer;
